export default __webpack_public_path__ + "static/media/StudioAccess.181d5d8b.webp";